import React, { memo } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import { CopyIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

const CopyButtonCDS = ({
  isDisabledTooltip = false,
  label = 'Copy',
  size = IconSize[16],
  tooltipPopperProps,
  onClick,
}) => (
  <Tooltip PopperProps={tooltipPopperProps} disableHoverListener={isDisabledTooltip} title={label}>
    <IconButton size="small" onClick={onClick}>
      <CopyIcon size={size} />
    </IconButton>
  </Tooltip>
);

CopyButtonCDS.propTypes = {
  isDisabledTooltip: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.number,
  tooltipPopperProps: PropTypes.object,
  onClick: PropTypes.func,
};

export default memo(CopyButtonCDS);
